import { errorStatus } from '@/lib/translateBackendError';

/**
 * Query `retry` policy for reads: retry network and server errors, never a 4xx.
 * A 4xx on a read is a verdict (signed out, no access, gone, invalid filter), so
 * a retry only delays the error state the page shows. Pass it as `retry` directly
 * for three retries, or wrap it to set `maxRetries`.
 */
export function retryUnlessClientError(
  failureCount: number,
  error: unknown,
  { maxRetries = 3 }: { maxRetries?: number } = {},
): boolean {
  const status = errorStatus(error);
  if (status !== undefined && status >= 400 && status < 500) return false;
  return failureCount < maxRetries;
}
